import quickscan from './quickscan';

export default {
    modules: {
        quickscan,
    },
    namespaced: true,
};
